import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_entity_to_entity_subsidiary_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    parent_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    child_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    shares_par_value: fromDatatype.NumericDatatypeInterface;
    shares_percent: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_mst_entity_to_entity_subsidiary_link_RowClass
  implements bl_fi_mst_entity_to_entity_subsidiary_link_RowInterface
{
    guid: fromDatatype.GuidDataFieldInterface;
    parent_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    child_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    shares_par_value: fromDatatype.NumericDatatypeInterface;
    shares_percent: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}
